import React, { useState } from "react";
import "../styles/Hero.css";
import contentData from "../data/content.json";
import FallBackImage from "../assets/images/hero/fallback.jpg";
import HeroVideo from "../assets/videos/HERO.mp4";

const Hero = () => {
    const [videoError, setVideoError] = useState(false);
    const { hero } = contentData;

    return (
        <div className="hero-container">
            {/* Video Background */}
            {!videoError && (
                <video
                    className="hero-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    onError={() => setVideoError(true)}
                >
                    <source src={HeroVideo} type="video/mp4" />
                </video>
            )}

            {/* Fallback Image */}
            {videoError && (
                <div
                    className="hero-fallback"
                    style={{ backgroundImage: `url(${FallBackImage})` }}
                />
            )}

            {/* Dark Overlay */}
            <div className="hero-overlay" />

            {/* Content */}
            <div className="hero-content">
                <p className="hero-subtitle-top">{hero.subtitle || "RAW ADVENTURER | NATURE EXPLORER | VISUAL STORYTELLER"}</p>
                <h1 className="hero-title">
                    {hero.title1 || "The World"}
                    <br />
                    {hero.title2 || "Belongs to "}
                    <span className="hero-title-italic">{hero.title3 || "The Brave"}</span>
                </h1>
                <p className="hero-description">
                    {hero.description || "Journey through uncharted landscapes, documenting the raw beauty of our planet"}
                </p>
            </div>
        </div>
    );
};

export default Hero;
